<template>
  
  <v-container fluid>
    <v-snackbar
			v-model="snackbar" top vertical="" :timeout="6000"
			>
			{{ Mensaje }}
			<v-btn
			color="pink"
			text
			@click="snackbar = false"
			>
			Close
			</v-btn>
        </v-snackbar>
	<v-dialog  v-model="dialogPrealerta"  max-width="1500" class="oculto-impresion primary">
		<v-card>
		<v-toolbar  dark color="primary" class="font-weight-light body-1">
			<h4>Cierres de Caja</h4>
		</v-toolbar>
		<v-card>
			<v-card-title>
				<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Buscar"
				single-line
				></v-text-field>
			</v-card-title>
			<v-data-table
				:headers="cabeceraDetalles"
				:items="Cierres"
				sort-by="numeroC"
				sort-desc="numeroC"
				:search="search"
			>
			<template v-slot:item.action="{ item }"> 
				<v-btn @click="ReimprimirCierre(item)"> <v-icon>mdi-cloud-print </v-icon> </v-btn>
			</template> 
			</v-data-table>
			</v-card>
			<v-btn color="error" @click="dialogPrealerta = false"> Salir </v-btn>
			</v-card>
	</v-dialog>
	<v-dialog persistent v-model="dialogCierre" fullscreen class="primary">
		<v-card>
			<html style="font-size:12px" id="bill" >
				<head style="text-align: center; align-content: center;">
					<div v-for="det in localidadencabezado" :key="det.nombre">
							
							<p style="text-align: center; align-content: center;"> 
								
								<b class="primary--text" >{{det.nombre}} </b> <br>{{det.razonSocial}},<br> {{det.dirreccion}}, Costa Rica
								<v-icon>mdi-id-card </v-icon> {{det.cedulaJuridica}} <v-icon>mdi-phone </v-icon> {{det.telefono}} <v-icon>mdi-email </v-icon>
								{{det.correo}} <br>
								---------------------- <br>
								{{fecha}}  <br>
								Usuario: {{$store.state.usuario.nombre}} <br>
								No Cierre : {{Cierres.length + 1}}
							</p>  
					</div>
					Datos del cierre
				</head>
				<body id="tiquete" class="content">
					<div v-if="Cierre_Resumen" class="ticket">
						Conteos en Dolares <br>
						Billetes de $100:{{dolar100}} <br>
						Billetes de $50:{{dolar50}} <br>
						Billetes de $20:{{dolar20}} <br>
						Billetes de $10{{dolar10}} <br>
						Billetes de $5:{{dolar5}}<br>
						Billetes de $2:{{dolar2}}<br>
						Billetes de $1:{{dolar1}} <br>
						Total: ${{monedaDolar}}<br>
						---------------------- <br>
						Conteos en colones <br>
						Billetes de 50.000:{{moneda50000}} <br>
						Billetes de 20.000:{{moneda20000}} <br>
						Billetes de 10.000:{{moneda10000}} <br>
						Billetes de 5.000:{{moneda5000}} <br>
						Billetes de 2.000:{{moneda2000}}<br>
						Billetes de 1.000:{{moneda1000}}<br>
						Monedas de 500:{{moneda500}} <br>
						Monedas de 100:{{moneda100}} <br>
						Monedas de 50:{{moneda50}} <br>
						Monedas de 25:{{moneda25}}<br>
						Monedas de 10:{{moneda10}}<br>
						Total: ₡{{ConteoColones}}<br>
						----------------------
						<div class="primary--text "> <b>Resumen del Conteo: ₡{{TotalConteo}} </b></div>
						<b> Total Conteo: $</b> {{(monedaDolar)}} <br>
						<b> Total Tarjetas: ₡</b> {{TotalTarjetas}} <br>
						<b> Fondo de Caja: ₡</b> {{FondoColones}} <br>
						<b> Fondo de Caja: $</b> {{FondoDolares}} <br>
						<b> Compras Caja Chica: ₡</b> {{TotalCompras}} <br>
						<b> IVA : ₡</b> {{ivaColones}} <br>
						<b> IVA: $</b> {{ivaDolares}}  <br>
						---------------------- <br>
					
						<div class="primary--text "> <b>Resumen del Cierre </b></div>
						<b> Ventas Efectivo: ₡</b> {{(VentasColonesEfectivo)}} <br>
						<b> Ventas Tarjeta: ₡</b> {{(VentasColonesTarjeta)}} <br>
						<b> Ventas Rappi: ₡</b> {{(VentasColonesRappi)}} <br>
						<b> ImpServicio: ₡</b> {{(ImpServicio)}} <br>
						<b> Ventas Transferencias: ₡</b> {{(VentaTransferenciaColones)}} <br>
						<b> Ventas Sinpe: ₡</b> {{(VentaTotalSinpeColones)}} <br>
						<b> Ventas NC: ₡</b> {{(VentasNCColon)}} <br>
						<b> Diferencia Efectivo:₡</b> {{ DiferenciaColones = (ConteoColones - ((FondoColones  + VentasColonesEfectivo + CreditosEfectivo - TotalCompras - NotasCreditoEfectivoColones)))}} <br>
						<b> Diferencia Tarjeta:₡</b> {{DiferenciaTarjetas=  (TotalTarjetas - (VentasColonesTarjeta + CreditosTarjeta - NotasCreditoTarjetaColones))}} <br>
						<b> Total Ventas: ₡</b> {{(parseFloat(VentasColonesEfectivo) +parseFloat(VentasColonesTarjeta) + parseFloat(VentaTransferenciaColones) + parseFloat(VentaTotalSinpeColones)
						+ parseFloat(CreditosEfectivo) + parseFloat(CreditosTarjeta) + parseFloat(CreditosDepositos) + parseFloat(CreditosSinpe) - parseFloat(NotasCreditoTarjetaColones) )}} 
						<br>
						---------------------- <br>
						<b> Facturado Efectivo: $</b> {{(VentasDolaresEfectivo)}} <br>
						<b> Facturado Tarjeta: $</b> {{VentasDolaresTarjeta}} <br>
						<b> Facturado Transferencia: $</b> {{VentaTransferenciaDolares}} <br>
						<b> Facturado Sinpe: $</b> {{VentasNCDolares}} <br>
						<b> Ventas NC: $</b> {{(VentasNCColon)}} <br>
						<b> Diferencia Efectivo: $</b> 0 <br>
						---------------------- <br>
						<b> Facturas a crédito: </b> {{FacturasCredito}} <br>
						<b> Abonos Crédito Efectivo: </b> {{CreditosEfectivo}} <br>
						<b> Abonos Crédito Tarjetas: </b> {{CreditosTarjeta}} <br>
						<b> Abonos Crédito Transferencias: </b> {{CreditosDepositos}} <br>
						<b> Abonos Crédito Sinpe: </b> {{CreditosSinpe}} <br>
						---------------------- <br>
						<b> Notas de credito Efectivo: ₡</b> {{NotasCreditoEfectivoColones}} <br>
						<b> Notas de credito Tarjeta: ₡</b> {{NotasCreditoTarjetaColones}} <br>
						<b> Notas de credito Transferencia: ₡</b> {{NotasCreditoTranferenciaColones}} <br>
						---------------------- <br>
						<b> Notas de credito Efectivo: $</b> {{NotasCreditoEfectivoDolares}} <br>
						<b> Notas de credito Tarjeta: $</b> {{NotasCreditoTarjetaDolares}} <br>
						<b> Notas de credito Transferencia: $</b> {{NotasCreditoTransferenciaDolares}} <br>
						---------------------- <br>
						
						<b> Salon: </b> {{VentasServicio}} <br>
						<b> Bar: </b> {{VentasSinServicioo}} <br>
						<b> Ventas Netas: ₡</b> {{VentasColonesEfectivo - ImpServicio +VentasColonesTarjeta + VentaTotalSinpeColones+VentaTransferenciaColones
						 +CreditosEfectivo+CreditosTarjeta+CreditosSinpe}} <br>
						<b> Ventas Netas: $</b> {{VentasDolaresEfectivo +VentasDolaresTarjeta + VentaTotalSinpeDolares}} <br>
						<b> Retiro en efectivo: ₡</b> {{RetiroEfectvo=(VentasColonesEfectivo -ImpServicio - TotalCompras)}} <br>
						<b> Retiro en efectivo: $</b> {{VentasDolaresEfectivo}} <br>
						<b> ImpServicio: ₡</b> {{(ImpServicio)}} <br>
						<h3>Resumen por Cajero</h3>
						<ul>
							<li v-for="cajero in resumenCajeros" :key="cajero.cajero">
								{{ cajero.cajero }}: ₡{{ cajero.total }}
							</li>
						</ul>
						<h3>Resumen por Vendedor</h3>
						<ul>
							<li v-for="vendedor in resumenVendedores" :key="vendedor.vendedor">
								{{ vendedor.vendedor }}: ₡{{ vendedor.total }}
							</li>
						</ul>
					</div>
					<div v-else>
						----------------------
						<div class="primary--text ">Efectivo </div>
						<b> Fondo Efectivo Apertura: ₡</b> {{FondoColones}} <br>
						<b> Fondo Efectivo Apertura: $</b> {{FondoDolares}} <br>
						<b> Fondo Efectivo Cierre: ₡{{TotalConteo}} </b>
						<b> Fondo Efectivo Cierre: $</b> {{(monedaDolar)}} <br>
						<b> Diferencia Descuadre:₡</b> {{ DiferenciaColones = (ConteoColones - ((FondoColones  + VentasColonesEfectivo + CreditosEfectivo - TotalCompras - NotasCreditoEfectivoColones)))}} <br>
						<b> Diferencia Descuadre: $</b> {{DiferenciaDolares=((VentasDolaresEfectivo +CreditosEfectivo -FondoDolares-NotasCreditoEfectivoDolares)-monedaDolar)}} <br>
						
						---------------------- <br>
					
						<div class="primary--text "> <b>Gastos Compras</b>{{TotalCompras}}  </div>
						
						<div class="primary--text "> <b>Facturado colones</b>{{TotalCompras}}  </div>
						
						<b> Ventas Efectivo: ₡</b> {{(VentasColonesEfectivo - NotasCreditoEfectivoColones)}} <br>
						<b> Ventas Tarjeta: ₡</b> {{(VentasColonesTarjeta - NotasCreditoTarjetaColones)}} <br>
						<b> Ventas Transferencias: ₡</b> {{(VentaTransferenciaColones)}} <br>
						<b> Ventas Sinpe: ₡</b> {{(VentaTotalSinpeColones)}} <br>
						<b> Total Ventas: ₡</b> {{(parseFloat(VentasColonesEfectivo) +parseFloat(VentasColonesTarjeta) + parseFloat(VentaTransferenciaColones) + parseFloat(VentaTotalSinpeColones)
						+ parseFloat(CreditosEfectivo) + parseFloat(CreditosTarjeta) + parseFloat(CreditosDepositos) + parseFloat(CreditosSinpe) - parseFloat(NotasCreditoTarjetaColones -parseFloat(NotasCreditoEfectivoColones)) )}} 
						<br>
						---------------------- <br>
						
						<div class="primary--text "> <b>Facturado Dolares </b>  </div>
						<b> Facturado Efectivo: $</b> {{(VentasDolaresEfectivo)}} <br>
						<b> Facturado Tarjeta: $</b> {{VentasDolaresTarjeta}} <br>
						<b> Facturado Transferencia: $</b> {{VentaTransferenciaDolares}} <br>
						<b> Facturado Sinpe: $</b> {{VentasNCDolares}} <br>
						<b> Ventas NC: $</b> {{(VentasNCColon)}} <br>
						---------------------- <br>
						
						<div class="primary--text "> <b>Resumen </b>  </div>
						<b> Salon: </b> {{VentasServicio}} <br>
						<b> Bar: </b> {{VentasSinServicioo}} <br>
						<b> Ventas Netas: ₡</b> {{VentasColonesEfectivo - ImpServicio +VentasColonesTarjeta + VentaTotalSinpeColones+VentaTransferenciaColones
						 +CreditosEfectivo+CreditosTarjeta+CreditosSinpe}} <br>
						<b> ImpServicio: ₡</b> {{(ImpServicio)}} <br>
						<h3>Resumen por Cajero</h3>
						<ul>
							<li v-for="cajero in resumenCajeros" :key="cajero.cajero">
								{{ cajero.cajero }}: ₡{{ cajero.total }}
							</li>
						</ul>
						<h3>Resumen por Vendedor</h3>
						<ul>
							<li v-for="vendedor in resumenVendedores" :key="vendedor.vendedor">
								{{ vendedor.vendedor }}: ₡{{ vendedor.total }}
							</li>
						</ul>
					</div>
				</body>
			</html>
				<v-btn class="primary mx-5 oculto-impresion" @click="ImprimirCierrePOS()"> <v-icon>mdi-printer</v-icon>Imprimir Impresora USB</v-btn>
				<v-btn class="primary mx-5 oculto-impresion" @click="ImprimirCierre()"> <v-icon>mdi-printer</v-icon>Imprimir Impresora Red</v-btn>
				<v-btn class="info mx-5 oculto-impresion"  @click="Cierre()"> <v-icon>mdi-cash-register</v-icon>Cerrar </v-btn>
		</v-card>
	</v-dialog>
	<div class="oculto-impresion">
			<v-img height="200"
				dark
				:src="require('@/assets/home-hero.jpg')"
				class="white--text pa-md-4 mx-lg-auto oculto-impresion"
				gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
			>
			<v-btn color="white" @click="dialogPrealerta = true" text rounded > <v-icon  >mdi-alarm-light</v-icon> Ver Cierres</v-btn>
			<v-btn color="white"  text rounded > <v-icon >mdi-account-circle</v-icon> Sesiones</v-btn>
			<div
				align="center"
				justify="center" >
				<v-col class="text-center" cols="12">
				<v-flex xs12>
				
				<h1 class="Titulo text-uppercase">{{Titulo}} de Caja</h1>
				<h4 class="subheading"> <v-icon> mdi-phone </v-icon>"4070-1889 Soporte"</h4> 
				</v-flex>
				
				</v-col>
			</div>
			</v-img>
			
			<div class="grey--text text-caption">
				<v-icon small> mdi-printer </v-icon> POS:{{ip1}} <v-icon small> mdi-printer </v-icon> DevId: {{devid1}}:
			</div>
			<v-layout wrap>
				<v-flex xs12 sm6 md3>
					<v-simple-table dense>
						<template >
						<thead>
							<tr>
							<th class="text-left">Denominación</th>
							<th class="text-left">Cantidad</th>
							<th class="text-left">Total</th>
							</tr>
						</thead>
						<tbody dense>
							<tr dense>
							<td>₡50.000</td>
							<td><v-text-field style="width:50%" height="15" onfocus="this.select();" type="number" dense v-model="moneda50000"> </v-text-field> </td>
							<td>{{calcular50000}}</td>
							</tr>
							<tr>
							<td>₡20.000</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda20000" > </v-text-field> </td>
							<td>{{calcular20000}}</td>
							</tr>
							<tr>
							<td>₡10.000</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda10000" > </v-text-field> </td>
							<td>{{calcular10000}}</td>
							</tr>
							<tr>
							<td>₡5.000</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda5000"> </v-text-field> </td>
							<td>{{calcular5000}}</td>
							</tr>
							<tr>
							<td>₡2.000</td>
							<td><v-text-field  style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda2000" > </v-text-field> </td>
							<td>{{calcular2000}}</td>
							</tr>
							<tr>
							<td>₡1.000</td>
							<td><v-text-field  style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda1000" > </v-text-field> </td>
							<td>{{calcular1000}}</td>
							</tr>
							<tr>
							<td>₡500</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda500"> </v-text-field> </td>
							<td>{{calcular500}}</td>
							</tr>
							<tr>
							<td>₡100</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda100" > </v-text-field> </td>
							<td>{{calcular100}}</td>
							</tr>
							<tr>
							<td>₡50</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda50" > </v-text-field> </td>
							<td>{{calcular50}}</td>
							</tr>
							<tr>
							<td>₡25</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda25" > </v-text-field> </td>
							<td>{{calcular25}}</td>
							</tr>
							<tr>
							<td>₡10</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="moneda10" > </v-text-field> </td>
							<td>{{calcular10}}</td>
							</tr>
							<tr>
							<td>₡5</td>
							<td><v-text-field style="width:50%" onfocus="this.select();" type="number" dense v-model="moneda5" > </v-text-field> </td>
							<td>{{calcular5}}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
				</v-flex>
				<v-flex xs12 sm6 md3>
						<v-simple-table dense>
							<template >
							<thead>
								<tr>
								<th class="text-left">Denominación</th>
								<th class="text-left">Cantidad</th>
								<th class="text-left">Total</th>
								</tr>
							</thead>
							<tbody dense>
								<tr dense>
								<td>$100</td>
								<td><v-text-field style="width:50%" height="15" onfocus="this.select();" type="number" dense v-model="dolar100"> </v-text-field> </td>
								<td>${{calculardolar100}}</td>
								</tr>
								<tr>
								<td>$50</td>
								<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar50" > </v-text-field> </td>
								<td>${{calculardolar50}}</td>
								</tr>
								<tr>
								<td>$20</td>
								<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar20" > </v-text-field> </td>
								<td>${{calculardolar20}}</td>
								</tr>
								<tr>
								<td>$10</td>
								<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar10"> </v-text-field> </td>
								<td>${{calculardolar10}}</td>
								</tr>
								<tr>
								<td>$5</td>
								<td><v-text-field  style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar5" > </v-text-field> </td>
								<td>${{calculardolar5}}</td>
								</tr>
								<tr>
								<td>$2</td>
								<td><v-text-field  style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar2" > </v-text-field> </td>
								<td>${{calculardolar2}}</td>
								</tr>
								<tr>
								<td>$1</td>
								<td><v-text-field style="width:50%" onfocus="this.select();" type="number"  dense v-model="dolar1"> </v-text-field> </td>
								<td>${{calculardolar1}}</td>
								</tr>
							</tbody>
							</template>
						</v-simple-table>
						<v-btn block dark color="boton" @click="TipoConteo()"> Imprimir Conteo </v-btn>
						<v-btn block dark color="boton" class="mt-2" @click="AbrirCajon()"> Abrir Cajón </v-btn>
						<v-btn :loading="loading" block dark color="boton" class="mt-2"  @click="Arqueo()"> Arqueo </v-btn>
						<v-btn block dark @click="Limpiar()" class="mt-2" color="boton">Limpiar</v-btn>
						
				</v-flex>
				<v-flex xs12 sm6 md6 >
					<v-card-title class="primary--text text-xl-h4 text-lg-h6 text-sm-body-2"> <b>Resumen de Datafonos: </b></v-card-title> <br/>
					<v-row>
						<v-text-field style="width:15%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoBCR" label="BCR CRC"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:15%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoBCRUsd" label="BCR USD"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:15%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoBAC" label="BAC CRC"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoBACUsd" label="BAC USD"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoPromerica" label="Promerica CRC"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoPromericaUsd" label="Promerica USD"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoNacional" label="Banco Nacional CRC"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoNacionalUsd" label="Banco Nacional USD"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoLafise" label="Lafise CRC"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field> 
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="ConteoDatafonoLafiseUsd" label="Lafise USD"
						hint="Digite el monto total de las transacciones de este datafono" > </v-text-field>
						<v-text-field style="width:20%" onfocus="this.select();" type="number"  outlined dense v-model="sinpeMovil" label="Sinpe Movil"
						hint="Digite el monto total de los depositos recibidos" persistent-hint > </v-text-field>  
					</v-row>
					<v-row  flat color="white"  class="rounded-xl var mx-5">
						<v-card-text>
							<v-card-title class="primary--text text-xl-h4 text-lg-h6 text-sm-body-2"> <b>Resumen del Conteo: ₡{{TotalConteo=(calcularConteo)}} </b></v-card-title>
							<b> Total Conteo: ₡</b> {{ConteoColones=(calcularConteo)}} <br>
							<b> Total Conteo: $</b> {{(monedaDolar=(calcularConteoDolar))}} <br>
							<b> Total Tarjetas: ₡</b> {{TotalTarjetas=(calcularTarjetas)}} <br>
							<b> Total Tarjetas: $</b> {{TotalTarjetasDolar=(calcularTarjetasDolares)}} <br>
							<b> Fondo de Caja: ₡</b> {{FondoColones}} <br>
							<b> Fondo de Caja: $</b> {{FondoDolares}} <br>
							<b> Resguardos: ₡</b> 0 <br>
							<b> Total Ventas: ₡</b> {{VentasColonesEfectivo - NotasCreditoEfectivoColones}} <br>
							<b> Tipo Cambio Interno: </b>{{TipoCambioInterno}}
						</v-card-text>
					</v-row>
					<v-btn v-if="!CierreGlobal" :loading="loading" @click="AlmacenarConteo()" class="pa-3 mt-2" block color="primary">Generar {{Titulo}} de Caja </v-btn>
					<v-btn v-else :loading="loading" @click="AlmacenarConteoGlobal()" class="pa-3 mt-2" block color="primary">Generar {{Titulo}} de Caja Global </v-btn>
				</v-flex>
			</v-layout>
		</div>
  </v-container>
</template>


<script>
  import { db } from '@/main'
  import axios from 'axios';
  
  export default {
    name: 'Conteos',
    data () {
      return {
        TipoCedula : '',
        detalles:[],
        search: '',
        Cierres: [],
        resCierre : false,
        loading : false,
        cabeceraDetalles: [
        { text: 'Numero Cierre', value: 'numeroC'},
		{ text: 'Reimprimir', value: 'action' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Hora', value: 'hora'  },
        { text: 'Cajero', value: 'cajero' },
        {text: 'Efectivo' , value: 'efectivo', sortable: false},
        { text: 'Tarjetas', value: 'tarjetas', sortable: false  },
        { text: 'Diferencia Efectivo', value: 'diferenciaE' },
        { text: 'Diferencia Tarjetas', value: 'diferenciaT'},
        { text: 'Dolares', value: 'dolares'},
        { text: 'BAC', value: 'tbac'},
        { text: 'Nacional', value: 'tbn'},
        { text: 'Promerica', value: 'tprom'},
        { text: 'Otros', value: 'totro'},
        { text: 'Depositado Efectivo', value: 'depositadoEfe'},
        { text: 'Deposito $', value: 'depositadoDol'},
        ],
        TipoCedulas: ["Fisica","Juridica","Dimex","Otro"],
        EstadoCivil: '',
        TipoCambio : 560,
        ConteoDatafonoBCR: 0,
        ConteoDatafonoBCR: 0,
        ConteoDatafonoLafise: 0,
		Multiplo: 5,
        ConteoDatafonoNacional: 0,
		Cierre_Resumen:true,
        ConteoDatafonoPromerica: 0,
        ConteoDatafonoBAC: 0,
		sinpeMovil:0,
        VentasColonesEfectivo: 0,
        VentasColonesTarjeta: 0,
        VentaTransferenciaColones: 0,
        VentaTransferenciaDolares: 0,
        VentasDolaresTarjeta: 0,
		VentasColonesRappi:0,
        VentasDolaresEfectivo: 0,
		ConteoDatafonoBCRUsd:0,
		ConteoDatafonoBACUsd:0,
		ConteoDatafonoPromericaUsd:0,
		ConteoDatafonoNacionalUsd:0,
		ConteoDatafonoLafiseUsd:0,
		snackbar: false,
		time: null,
		CreditosEfectivo:0,
		CreditosTarjeta:0,
		CreditosDepositos:0,
		resumenCajeros: [],
        resumenVendedores: [],
		Mensaje: "",
        NotasCreditoEfectivoColones: 0,
		ip1: "",
		devid2: "",
		ip2: "",
		devid1: "",
        localidadencabezado: [],
        Logo2: '',
		ivaColones:0,
		TotalConteo:0,
		ivaDolares: 0,
        NotasCreditoTarjetaColones: 0,
        NotasCreditoEfectivoDolares: 0,
        NotasCreditoTarjetaDolares: 0,
        NotasCreditoTranferenciaColones: 0,
        NotasCreditoTransferenciaDolares: 0,
        DiferenciaColones : 0,
		RetiroEfectvo:0,
        DiferenciaDolares: 0,
        DiferenciaTarjetas: 0,
        DiferenciaDepositos: 0,
        Profesion: '',
        TotalTarjetas: 0,
		TotalTarjetasDolar: 0,
        TotalCompras: 0,
		mododPDV: 0,
        ConteoColones: 0,
        moneda50000: 0,
		FacturasCredito:0,
        moneda20000: 0,
        moneda10000: 0,
        moneda5000: 0,
        moneda2000: 0,
        moneda1000: 0,
        moneda500: 0,
        moneda50: 0,
        moneda100: 0,
        moneda25: 0,
		moneda10: 0,
		moneda5:0,
        monedaDolar: 0,
		dolar100: 0,
		dolar50:0,
		VentasNCColon:0,
		VentasNCDolares:0,
		dolar20:0,
		dolar10:0,
		dolar5:0,
		dolar2:0,
		dolar1:0,
        ImpServicio: 0,
        Cedula: '',
        FondoColones:0,
		modoPDV:0,
		TipoCambioInterno:0,
        FondoDolares: 0.0,
        dialogCierre: false,
        Direccion: '',
        telefonoMovil: '',
        fecha: '',
        telefonoCasa: '',
        Provincia: '',
        Titulo: this.$route.params.id,
        e6: 1,
        imageData: null,
        picture: null,
        uploadValue: 0,
		VentasSinServicioo:0,
		VentasServicio:0,
        dragAndDropCapable: false,
		VentaTotalSinpeColones:0,
		CierreGlobal:false,
		VentaTotalSinpeDolares:0,
        dialogPrealerta: false,
        selectedFile: null,
		Localidad : "",
        valordelpaquete:0,
		CreditosSinpe:0,
        tienda : '',

      }
    },
    computed: {
	calcularConteo:function(){
		var resultado=0;
			resultado=this.calcular50000 + this.calcular20000+ this.calcular10000 + this.calcular5000 + this.calcular2000
			+ this.calcular1000 + this.calcular500 + this.calcular100 + this.calcular50 + this.calcular25 + this.calcular10 + this.calcular5;
		
		return resultado;
    },
	calcularConteoDolar:function(){
		var resultado=0;
			resultado=this.calculardolar100 + this.calculardolar50+ this.calculardolar20 + this.calculardolar10 + this.calculardolar5
			+ this.calculardolar2 + this.calculardolar1;
		return resultado;
    },
    calcularTarjetas:function(){
        var resultado=0;
          resultado= parseFloat(this.ConteoDatafonoLafise) + parseFloat(this.ConteoDatafonoNacional)+ parseFloat(this.ConteoDatafonoPromerica) 
          + parseFloat(this.ConteoDatafonoBAC) + parseFloat(this.ConteoDatafonoBCR);
        
        return resultado;
    },
	calcularTarjetasDolares:function(){
        var resultado=0;
          resultado= parseFloat(this.ConteoDatafonoBCRUsd) + parseFloat(this.ConteoDatafonoBACUsd)+ parseFloat(this.ConteoDatafonoPromericaUsd) 
          + parseFloat(this.ConteoDatafonoNacionalUsd) + parseFloat(this.ConteoDatafonoLafiseUsd);
        
        return resultado;
    },
	calcular50000:function(){
        var resultado=0;
          resultado=this.moneda50000 * 50000 ;
        
        return resultado;
    },
    calcular20000:function(){
        var resultado=0;
          resultado=this.moneda20000 * 20000 ;
        
        return resultado;
    },
    calcular10000:function(){
        var resultado=0;
          resultado=this.moneda10000 * 10000 ;
        
        return resultado;
    },
    calcular5000:function(){
        var resultado=0;
          resultado=this.moneda5000 * 5000 ;
        
        return resultado;
    },
    calcular2000:function(){
        var resultado=0;
          resultado=this.moneda2000 * 2000 ;
        
        return resultado;
    },
    calcular1000:function(){
        var resultado=0;
          resultado=this.moneda1000 * 1000 ;
        
        return resultado;
    },
    calcular500:function(){
        var resultado=0;
          resultado=this.moneda500 * 500 ;
        
        return resultado;
    },
    calcular100:function(){
        var resultado=0;
          resultado=this.moneda100 * 100 ;
        
        return resultado;
    },
    calcular50:function(){
        var resultado=0;
          resultado=this.moneda50 * 50 ;
        
        return resultado;
    },
    calcular25:function(){
        var resultado=0;
          resultado=this.moneda25 * 25 ;
        
        return resultado;
    },
    calcular10:function(){
        var resultado=0;
          resultado=this.moneda10 * 10 ;
        
        return resultado;
	},
	calcular5:function(){
        var resultado=0;
          resultado=this.moneda5 * 5 ;
        
        return resultado;
    },
	calculardolar100:function(){
        var resultado=0;
			resultado=this.dolar100 * 100 ;
        return resultado;
    },
	calculardolar50:function(){
        var resultado=0;
          resultado=this.dolar50 * 50 ;
        
        return resultado;
    },
	calculardolar20:function(){
        var resultado=0;
          resultado=this.dolar20 * 20 ;
        
        return resultado;
    },
	calculardolar10:function(){
        var resultado=0;
          resultado=this.dolar10 * 10 ;
        
        return resultado;
	},
	calculardolar5:function(){
        var resultado=0;
          resultado=this.dolar5 * 5 ;
        
        return resultado;
    },
	calculardolar2:function(){
        var resultado=0;
          resultado=this.dolar2 * 2 ;
        
        return resultado;
    },
	calculardolar1:function(){
        var resultado=0;
          resultado=this.dolar1 * 1 ;
        
        return resultado;
    },
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
    created () {
      this.BuscarFondos();
	  this.validarImpresora();
      this.CierresCaja();
      this.listarLocalidad();
	  this.TipoCambio2();
	  this.selectPanelControl();
	  this.TipoCierre();
	  setTimeout(() => {
			this.validarConteo();
		}, 5000); // 5000 milisegundos equivalen a 5 segundos
    },
    methods: {

		CierresCaja() {
		let me = this;
		let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/CierreCajas/ListarCierres/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.Cierres=response.data;
			}).catch(function(error){
				console.log(error);
			});
		},
		TipoCierre(){
			if(this.$store.state.usuario.localidad === 'Gitana'){
				this.Cierre_Resumen = false;
			} 
		},
		async selectPanelControl(){  
			let me=this;
			var localidadesArray=[];
			this.Localidad = this.$store.state.usuario.localidad.trim();
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/PanelControls/ListarLocalidad/'+this.Localidad,configuracion).then(function(response){
				localidadesArray=response.data;
				me.CierreGlobal =  localidadesArray[0].cierreGlobal;
				//me.Cierre_Resumen =  localidadesArray[0].otros;
				
			})
		},
		TipoCambio2(){
			let me=this;
			var localidadesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ParametrosEmisors/ListarLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
			localidadesArray=response.data;
			me.TipoCambioInterno= localidadesArray[0].tipoCambio;
			
			})
		},
		listarLocalidad(){
			var today = new Date();
			var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
			var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
			this.fecha = date+' '+time;
			let me =this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
				axios.get('api/Localidades/ListarFiltrada/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
					//console.log(response);
					me.localidadencabezado=response.data;
					me.Logo2 = me.localidadencabezado[0].imagen;
					me.modoPDV = me.localidadencabezado[0].modoPDV;
				}).catch(function(error){
					console.log(error);
				});

		},
    	async BuscarFondos(){
			let me=this;
			var resultado=0.0;
			let resumenCont = [];
			this.Localidad = this.$store.state.usuario.localidad.trim();
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.get('api/Conteos/ListarFondos/'+this.Localidad+'/'+this.$store.state.usuario.nombre+'',configuracion).then(function(response){
				//console.log(response);
				resumenCont=response.data;
			for(var i=0;i<resumenCont.length;i++){
					me.FondoColones=me.FondoColones+(resumenCont[i].montoEfectivo * 1);
					me.FondoDolares = me.FondoDolares+(resumenCont[i].montoDolares * 1);
			}
			}).catch(function(error){
				console.log(error);
			});
		},
		validarConteo(){
			if(this.ip1 == "" && this.devid1 == ""){
				//alert("No hay impresora designada");
				return;	
			}
            var request = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
						<text align="center"/>
						<text font="font_c"/>
						<text width="3" height="3"/>
						<text reverse="false" ul="false" em="false" color="color_1"/>
						<text>Conteo &#10;</text>
						<text width="1" height="1"/>
						<text>Usuario: `+this.$store.state.usuario.nombre+`&#9;</text>
						<text>Localidad:`+this.$store.state.usuario.localidad+` &#10;</text>
						<text>Hora `+time+`&#9;</text> <text>Fecha `+this.fecha+`&#9;</text>
						<text>-------------------------------------&#10;</text>
						<text align="left"/>
						<text>Billetes de 50.000:`+this.moneda50000+` &#10;</text>
						<text>Billetes de 20.000:`+this.moneda20000+` &#10;</text>
						<text>Billetes de 10.000:`+this.moneda10000+` &#10;</text>
						<text>Billetes de 5.000:`+this.moneda5000+` &#10;</text>
						<text>Billetes de 2.000:`+this.moneda2000+` &#10;</text>
						<text>Billetes de 1.000:`+this.moneda1000+` &#10;</text>
						<text>Billetes de 500:`+this.moneda500+` &#10;</text>
						<text>Billetes de 100:`+this.moneda100+` &#10;</text>
						<text>Billetes de 50:`+this.moneda50+` &#10;</text>
						<text>Billetes de 25:`+this.moneda25+` &#10;</text>
						<text>Billetes de 10:`+this.moneda10+` &#10;</text> 
						<text>Total: `+this.ConteoColones+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Resumen Conteo:₡ `+this.TotalConteo+` &#10;</text>
						<feed line="3"/>
						<cut type="feed"/>
						<pulse drawer="drawer_1" time="pulse_100"/>
						</epos-print>`;
                
                //Create a SOAP envelop
                var soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<s:Body>' + request + '</s:Body></s:Envelope>';
                //Create an XMLHttpRequest object
                var xhr = new XMLHttpRequest();
                //Set the end point address
                var url = 'http://'+this.ip1+'/cgi-bin/epos/service.cgi?devid='+this.devid1+'&timeout=40000';
                //Open an XMLHttpRequest object
                xhr.open('POST', url, true);
                //<Header settings>
                xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
                xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
                // Send print document
                xhr.send(soap);
		
		},
		async Arqueo(){
			let me=this;
			me.resCierre = true;
			var resultado=0.0;
			let resumenCont = [];
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			try {
				const response = await axios.get(`api/Facturas/ListarAuxCierre/${this.Localidad}/${this.$store.state.usuario.nombre}`, configuracion);
				resumenCont = response.data;

			for (var i = 0; i < resumenCont.length; i++) {
				var item = resumenCont[i];
				
				if (item.tipoDocumento === "TIQUETE ELECTRONICO" || item.tipoDocumento === "FACTURA ELECTRONICA" || item.tipoDocumento === "RECIBO") {
					if (item.moneda === "CRC") {
						me.VentasColonesEfectivo += item.totalEfectivo;
						me.VentasColonesTarjeta += item.totalTarjeta;
						me.VentaTransferenciaColones += item.totalDeposito;
						me.VentaTotalSinpeColones += item.totalSimpe;
						me.ivaColones += item.impuesto13;
						me.VentasDolaresEfectivo += item.totalDolares;
					} else if (item.moneda === "USD") {
						me.VentasDolaresEfectivo += item.totalEfectivo; // Asegúrate de usar la variable correcta
						me.VentasDolaresTarjeta += item.totalTarjeta;
						me.VentaTransferenciaDolares += item.totalDeposito;
						me.VentaTotalSinpeDolares += item.totalSimpe;
						me.ivaDolares += item.impuesto13;
					}
				} else if (item.tipoDocumento === "NOTA DE CREDITO") {
					if (item.moneda === "CRC") {
						if (item.tipoPago === "EFECTIVO") {
							me.NotasCreditoEfectivoColones += item.total;
						} else if (item.tipoPago === "TARJETA") {
							me.NotasCreditoTarjetaColones += item.total;
						} else if (item.tipoPago === "DEPOSITO" || item.tipoPago === 'SINPE' || item.tipoPago === 'TRANSFERENCIA') {
							me.NotasCreditoTransferenciaColones += item.total;
						}
					} else if (item.moneda === "USD") {
						if (item.tipoPago === "EFECTIVO") {
							me.NotasCreditoEfectivoDolares += item.total;
						} else if (item.tipoPago === "TARJETA") {
							me.NotasCreditoTarjetaDolares += item.total;
						} else if (item.tipoPago === "TRANSFERENCIA") {
							me.NotasCreditoTransferenciaDolares += item.total;
						}
					}
				}
				if(item.impServicio > 0){
					me.VentasServicio += item.total;
				} else
				{
					me.VentasSinServicioo += item.total;
				}
				
				me.ImpServicio += item.impServicio;
			}
			} catch (error) {
				console.log(error);
			}
			
			me.BuscarCompras();
			me.BuscarCreditos();
			//me.GenerarCierre();
			me.loading =false;
		},
		async BuscarVentasCredito(){
			let me = this;
			me.resCierre = true;
			let resumenCont = [];
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarAuxCreditos/${this.Localidad}/${this.$store.state.usuario.nombre}`, configuracion);
				resumenCont = response.data;
				
				me.FacturasCredito = resumenCont;

			} catch (error) {
				console.log(error);
			}
		},
		async BuscarVentasCreditoGlobal(){
			let me = this;
			me.resCierre = true;
			let resumenCont = [];
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarAuxCreditosGlobal/${this.$store.state.usuario.localidad}`, configuracion);
				resumenCont = response.data;
				me.FacturasCredito = resumenCont;

			} catch (error) {
				console.log(error);
			}
		},
    	async BuscarVentas() {
			let me = this;
			me.resCierre = true;
			let resumenCont = [];
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarAuxCierre/${this.Localidad}/${this.$store.state.usuario.nombre}`, configuracion);
				resumenCont = response.data;

				for (let item of resumenCont) {
					if (item.tipoDocumento === "NOTA DE CREDITO") {
						// Procesar notas de crédito separadamente
						if (item.moneda === "CRC") {
							if (item.tipoPago === "EFECTIVO") {
								me.NotasCreditoEfectivoColones += item.total;
							} else if (item.tipoPago === "TARJETA") {
								me.NotasCreditoTarjetaColones += item.total;
							} else if (["DEPOSITO", "SINPE", "TRANSFERENCIA"].includes(item.tipoPago)) {
								me.NotasCreditoTransferenciaColones += item.total;
							}
						} else if (item.moneda === "USD") {
							if (item.tipoPago === "EFECTIVO") {
								me.NotasCreditoEfectivoDolares += item.total;
							} else if (item.tipoPago === "TARJETA") {
								me.NotasCreditoTarjetaDolares += item.total;
							} else if (item.tipoPago === "TRANSFERENCIA") {
								me.NotasCreditoTransferenciaDolares += item.total;
							}
						}
						if(item.impServicio > 0){
							me.VentasServicio -= item.total;
						} else {
							me.VentasSinServicioo -= item.total;
						}
					} else if (["TIQUETE ELECTRONICO", "FACTURA ELECTRONICA", "RECIBO"].includes(item.tipoDocumento)) {
						// Procesar otros documentos
						if (item.moneda === "CRC") {
							me.VentasColonesEfectivo += item.totalEfectivo;
							me.VentasColonesTarjeta += item.totalTarjeta;
							me.VentaTransferenciaColones += item.totalDeposito;
							me.VentaTotalSinpeColones += item.totalSimpe;
							me.ivaColones += item.impuesto13;
							me.VentasDolaresEfectivo += item.totalDolares;
							me.VentasNCColon += item.totalNC;
						} else if (item.moneda === "USD") {
							me.VentasDolaresEfectivo += item.totalEfectivo;
							me.VentasDolaresTarjeta += item.totalTarjeta;
							me.VentaTransferenciaDolares += item.totalDeposito;
							me.VentaTotalSinpeDolares += item.totalSimpe;
							me.ivaDolares += item.impuesto13;
							me.VentasNCDolares += item.totalNC;
						}
						if(item.impServicio > 0){
							me.VentasServicio += item.total;
						} else {
							me.VentasSinServicioo += item.total;
						}
					}

					me.ImpServicio += item.impServicio;
				}

				me.BuscarCompras();
				me.BuscarCreditos();
			} catch (error) {
				console.log(error);
			}
		},

		resetValues() {
			// Reinicia todas las variables de sumas a cero
			this.VentasColonesEfectivo = 0;
			this.VentasColonesTarjeta = 0;
			this.VentaTransferenciaColones = 0;
			this.VentaTotalSinpeColones = 0;
			this.ivaColones = 0;
			this.VentasDolaresEfectivo = 0;
			this.VentasDolaresTarjeta = 0;
			this.VentaTransferenciaDolares = 0;
			this.VentaTotalSinpeDolares = 0;
			this.ivaDolares = 0;
			this.VentasNCColon = 0;
			this.VentasNCDolares = 0;
			this.NotasCreditoEfectivoColones = 0;
			this.NotasCreditoTarjetaColones = 0;
			this.NotasCreditoEfectivoDolares = 0;
			this.NotasCreditoTarjetaDolares = 0;
			this.VentasServicio = 0;
			this.VentasSinServicioo = 0;
			this.ImpServicio = 0;
		},
		async BuscarVentasVendedoresGlobal(){
			let me = this;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarResumenCierreGlobal/${this.$store.state.usuario.localidad}`, configuracion);
				const data = response.data;
				me.resumenCajeros = data.resumenCajeros;
				me.resumenVendedores = data.resumenVendedores;
			} catch (error) {
				console.log(error);
			}
		},
		async BuscarVentasVendedores(){
			let me = this;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarResumenCierreGlobalUsuario/${this.Localidad}/${this.$store.state.usuario.nombre}`, configuracion);
				const data = response.data;
				me.resumenCajeros = data.resumenCajeros;
				me.resumenVendedores = data.resumenVendedores;
			} catch (error) {
				console.log(error);
			}
		},
		async BuscarVentasGlobal() {
			let me = this;
			me.resCierre = true;
			let resumenCont = [];
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			try {
				const response = await axios.get(`api/Facturas/ListarAuxCierreGlobal/${this.Localidad}`, configuracion);
				resumenCont = response.data;
			for (var i = 0; i < resumenCont.length; i++) {
				var item = resumenCont[i];
				
				if (item.tipoDocumento === "TIQUETE ELECTRONICO" || item.tipoDocumento === "FACTURA ELECTRONICA" || item.tipoDocumento === "RECIBO") {
					if (item.moneda === "CRC") {
						me.VentasColonesEfectivo += item.totalEfectivo;
						me.VentasColonesTarjeta += item.totalTarjeta;
						me.VentaTransferenciaColones += item.totalDeposito;
						me.VentaTotalSinpeColones += item.totalSimpe;
						me.ivaColones += item.impuesto13;
						me.VentasDolaresEfectivo += item.totalDolares;
						me.VentasNCColon += item.totalNC;
					} else if (item.moneda === "USD") {
						me.VentasDolaresEfectivo += item.totalEfectivo; // Asegúrate de usar la variable correcta
						me.VentasDolaresTarjeta += item.totalTarjeta;
						me.VentaTransferenciaDolares += item.totalDeposito;
						me.VentaTotalSinpeDolares += item.totalSimpe;
						me.ivaDolares += item.impuesto13;
						me.VentasNCDolares += item.totalNC;
					}
				} else if (item.tipoDocumento === "NOTA DE CREDITO") {
					if (item.moneda === "CRC") {
						if (item.tipoPago === "EFECTIVO") {
							me.NotasCreditoEfectivoColones += item.total;
						} else if (item.tipoPago === "TARJETA") {
							me.NotasCreditoTarjetaColones += item.total;
						} else if (item.tipoPago === "DEPOSITO" || item.tipoPago === 'SINPE' || item.tipoPago === 'TRANSFERENCIA') {
							me.NotasCreditoTransferenciaColones += item.total;
						}
					} else if (item.moneda === "USD") {
						if (item.tipoPago === "EFECTIVO") {
							me.NotasCreditoEfectivoDolares += item.total;
						} else if (item.tipoPago === "TARJETA") {
							me.NotasCreditoTarjetaDolares += item.total;
						} else if (item.tipoPago === "TRANSFERENCIA") {
							me.NotasCreditoTransferenciaDolares += item.total;
						}
					}
				}
				if(item.impServicio > 0){
					me.VentasServicio += item.total;
				} else
				{
					me.VentasSinServicioo += item.total;
				}
				me.ImpServicio += item.impServicio;
			}


				me.BuscarComprasGlobal();
				me.BuscarCreditosGlobal();
			} catch (error) {
				console.log(error);
			}
		},
		async BuscarCreditosGlobal() {
			let me = this;
			this.dialogCierre = true;
			this.CreditosEfectivo = 0;
			this.CreditosTarjeta = 0;
			this.CreditosDepositos = 0;
			let header = {"Authorization" : "Bearer " + this.$store.state.usuario.token}; // Asegúrate de agregar el token de usuario.
			let configuracion = {headers : header};

			try {
				let url = 'api/Abonoscxc/TotalAbonosPorTipoPagoGlobal/' + this.$store.state.usuario.localidad;
				let response = await axios.get(url, configuracion);
				
				response.data.forEach(item => {
					switch(item.tipoPago) {
						case 'EFECTIVO':
							me.CreditosEfectivo += item.totalAbonos;
							break;
						case 'TARJETA':
							me.CreditosTarjeta += item.totalAbonos;
							break;
						case 'DEPOSITO':
							me.CreditosDepositos += item.totalAbonos;
							break;
						case 'SINPE':
							me.CreditosSinpe += item.totalAbonos;
						break;
						default:
							console.warn('Tipo de pago no reconocido: ' + item.tipoPago);
					}
				});
				
				me.GenerarCierreGlobal();
			} catch (error) {
				console.error('Error al obtener los abonos: ', error);
				// Puedes manejar el error de manera más adecuada aquí, por ejemplo, mostrando un mensaje al usuario.
			}
		},
		async BuscarCreditos() {
			let me = this;
			this.dialogCierre = true;
			this.CreditosEfectivo = 0;
			this.CreditosTarjeta = 0;
			this.CreditosDepositos = 0;
			let header = {"Authorization" : "Bearer " + this.$store.state.usuario.token}; // Asegúrate de agregar el token de usuario.
			let configuracion = {headers : header};

			try {
				let url = 'api/Abonoscxc/TotalAbonosPorTipoPago/' + this.Localidad + '/' + this.$store.state.usuario.nombre;
				let response = await axios.get(url, configuracion);
				
				response.data.forEach(item => {
					switch(item.tipoPago) {
						case 'EFECTIVO':
							me.CreditosEfectivo += item.totalAbonos;
							break;
						case 'TARJETA':
							me.CreditosTarjeta += item.totalAbonos;
							break;
						case 'DEPOSITO':
							me.CreditosDepositos += item.totalAbonos;
							break;
						case 'SINPE':
							me.CreditosSinpe += item.totalAbonos;
						break;
						default:
							console.warn('Tipo de pago no reconocido: ' + item.tipoPago);
					}
				});
				
				me.GenerarCierre();
			} catch (error) {
				console.error('Error al obtener los abonos: ', error);
				// Puedes manejar el error de manera más adecuada aquí, por ejemplo, mostrando un mensaje al usuario.
			}
		},
		validarImpresora(){
			let me=this;
			var localidadesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Impresoras/ListarLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				localidadesArray=response.data;
				me.localidad = localidadesArray;
					for(var i = 0; i < localidadesArray.length; ++i){
						if(localidadesArray[i].nombreImpresora == "Caja"){
							me.ip1 = localidadesArray[i].ip
							me.devid1 = localidadesArray[i].devid
							me.existeprinter1 = true;
						}
					}
					
			})
		},
		async BuscarCompras(){
			let me=this;
			var resultado=0.0;
			let resumenCont = [];
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.get('api/FacturasCompras/ListarCierre/'+this.Localidad+'/'+this.$store.state.usuario.nombre+'',configuracion).then(function(response){
				//console.log(response);
				resumenCont=response.data;
			for(var i=0;i<resumenCont.length;i++){
					me.TotalCompras += resumenCont[i].total;
				}
			}).catch(function(error){
				console.log(error);
			});
			
		},
		async BuscarComprasGlobal(){
			let me=this;
			var resultado=0.0;
			let resumenCont = [];
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.get('api/FacturasCompras/ListarCierreGlobal/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				resumenCont=response.data;
			for(var i=0;i<resumenCont.length;i++){
					me.TotalCompras += resumenCont[i].total;
				}
			}).catch(function(error){
				console.log(error);
			});
		},
		Download(Doc){
		axios({
			url:"Doc",
			method:'GET',
			responseType: 'blob'
		}).then((response) => {
			var fileUrl = window.URL.createObjectURL(new Blob([responde.data]))
			varfileLink = document.createElement('a')
			FileLink.href = fileUrl
		})

		},
		salir(){
		this.$store.dispatch("salir");
		},
		AlmacenarConteo() 
			{    
			if(this.Titulo == "Cierre"){
				this.loading = true;
				this.BuscarVentasCredito();
				this.BuscarVentasVendedores();
				this.BuscarVentas();
				
				return;
			}
			var linkProforma = location.origin+'/pos';
			var tipo = 'FONDO DE CAJA'
			this.loading = true;
			var self = this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.post('api/Conteos/Crear',{
				'Localidad':this.$store.state.usuario.localidad,
				'Cajero':this.$store.state.usuario.nombre,
				'MontoEfectivo': this.ConteoColones,
				'MontoDolares':this.monedaDolar,
				'TipoContador':tipo,
			},configuracion).then(function (response) {
				
				self.ImprimirCierre();
			alert("Apertura de Caja realizada de forma éxitosa");
			location.assign(linkProforma); 
			}).catch(function(error){
				alert('Error almacenando el conteo');
			}); 
		
		},
		AlmacenarConteoGlobal() 
			{    
			if(this.Titulo == "Cierre"){
				this.loading = true;
				this.BuscarVentasCreditoGlobal();
				this.BuscarVentasVendedoresGlobal();
				this.BuscarVentasGlobal();
				
				return;
			}
			var linkProforma = location.origin+'/pos';
			var tipo = 'FONDO DE CAJA'
			this.loading = true;
			var self = this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.post('api/Conteos/Crear',{
				'Localidad':this.$store.state.usuario.localidad,
				'Cajero':this.$store.state.usuario.nombre,
				'MontoEfectivo': this.ConteoColones,
				'MontoDolares':this.monedaDolar,
				'TipoContador':tipo,
			},configuracion).then(function (response) {
				
				self.ImprimirCierre();
			alert("Apertura de Caja realizada de forma éxitosa");
			location.assign(linkProforma); 
			}).catch(function(error){
				alert('Error almacenando el conteo');
			}); 
		
		},
		ImprimirCierre(){
			var momentoActual = new Date(); 
			var hora = momentoActual.getHours(); 
			var minuto = momentoActual.getMinutes(); 
			var segundo = momentoActual.getSeconds();
			var time = hora + ":" + minuto + ":" + segundo;
			var Año = momentoActual.getFullYear(); 
			var Mes = momentoActual.getMonth(); 
			var Dia = momentoActual.getDate();
			var DepositarEfectivo = parseInt(this.VentasColonesEfectivo) - parseInt(this.FondoColones) - parseInt(this.TotalCompras);
			var TotalVentas = parseFloat(this.VentasColonesEfectivo) + parseFloat(this.VentasColonesTarjeta) +parseFloat(this.VentaTransferenciaColones) +parseFloat(this.VentaTotalSinpeColones);
			this.start =  Dia + "-"+"0" + Mes + "-"+"0" + Año;
			var IdCierre = parseInt(this.Cierres.length) +1;
			var request = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
						<text align="center"/>
						<text font="font_c"/>
						<text width="3" height="3"/>
						<text reverse="false" ul="false" em="false" color="color_1"/>
						<text>`+this.Titulo+` Caja &#10;</text>
						<text width="1" height="1"/>
						<text>Usuario: `+this.$store.state.usuario.nombre+`&#9;</text>
						<text>Localidad:`+this.$store.state.usuario.localidad+` &#10;</text>
						<text>Hora `+time+`&#9;</text> <text>Fecha `+this.start+`&#9;</text>
						<text>ID:`+IdCierre+`&#10;</text>
						<text>-------------------------------------&#10;</text>
						<text align="left"/>
						<text>Billetes de 50.000:`+this.moneda50000+` &#10;</text>
						<text>Billetes de 20.000:`+this.moneda20000+` &#10;</text>
						<text>Billetes de 10.000:`+this.moneda10000+` &#10;</text>
						<text>Billetes de 5.000:`+this.moneda5000+` &#10;</text>
						<text>Billetes de 2.000:`+this.moneda2000+` &#10;</text>
						<text>Billetes de 1.000:`+this.moneda1000+` &#10;</text>
						<text>Billetes de 500:`+this.moneda500+` &#10;</text>
						<text>Billetes de 100:`+this.moneda100+` &#10;</text>
						<text>Billetes de 50:`+this.moneda50+` &#10;</text>
						<text>Billetes de 25:`+this.moneda25+` &#10;</text>
						<text>Billetes de 10:`+this.moneda10+` &#10;</text> 
						<text>Total: `+this.ConteoColones+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Ingresado Promerica: `+this.ConteoDatafonoPromerica+` &#10;</text>
						<text>Ingresado BCR: `+this.ConteoDatafonoBCR+` &#10;</text>
						<text>Ingresado BAC: `+this.ConteoDatafonoBAC+` &#10;</text>
						<text>Ingresado Nacional: `+this.ConteoDatafonoNacional+` &#10;</text>
						<text>Ingresado Lafise: `+this.ConteoDatafonoLafise+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Total Conteo $: `+this.monedaDolar+` &#10;</text>
						<text>Total Tarjetas ₡: `+this.TotalTarjetas+` &#10;</text>
						<text>Fondo de Caja Colones `+this.FondoColones+` &#10;</text>
						<text>Fondo de Caja Dolares `+this.FondoDolares+` &#10;</text>
						<text>Compras Caja Chica Colones `+this.TotalCompras+` &#10;</text>
						<text>IVA Colones`+this.ivaColones+` &#10;</text>
						<text>IVA Dolares`+this.ivaDolares+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Resumen del Cierre &#10;</text>
						<text>Ventas Efectivo`+this.VentasColonesEfectivo+` &#10;</text>
						<text>Ventas Tarjeta: `+this.VentasColonesTarjeta+` &#10;</text>
            			<text>Impuesto Servicio:  `+this.ImpServicio+` &#10;</text>
            			<text>Ventas Transferencia:  `+this.VentaTransferenciaColones+` &#10;</text>
						<text>Ventas Sinpe: `+this.VentaTotalSinpeColones+` &#10;</text>
						<text>Diferencia Tarjetas Colones `+this.DiferenciaTarjetas+` &#10;</text>
						<text>Diferencia Efectivo Colones `+this.DiferenciaColones +` &#10;</text>

						<text>-------------------------------------&#10;</text>
						<text>Facturas a crédito: `+this.FacturasCredito+` &#10;</text>
						<text>Recibido Crédito Efectivo: `+this.CreditosEfectivo+` &#10;</text>
						<text>Recibido Crédito Tarjetas: `+this.CreditosTarjeta+` &#10;</text>
						<text>Recibido Crédito Transferencias: `+this.CreditosDepositos+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Conteo Tarjetas `+this.TotalTarjetas+` &#10;</text>
						<text>Facturado en Tarjeta: `+this.VentasColonesTarjeta+` &#10;</text>
						<text>Diferencia Tarjetas: `+this.DiferenciaTarjetas+` &#10;</text>
						<text>Ventas en Transferencia:  `+this.VentaTransferenciaColones+` &#10;</text>
						<text>Ventas en Sinpe:  `+this.VentaTotalSinpeColones+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Notas de credito Efectivo:  `+this.NotasCreditoEfectivoColones +` &#10;</text>
						<text>Notas de credito Tarjeta:  `+this.NotasCreditoTarjetaColones+` &#10;</text>
						<text>Total Ventas:  `+ TotalVentas +` &#10;</text>
						<text>Depositar Efectivo:  `+ this.RetiroEfectvo +` &#10;</text>
						<feed line="3"/>
						<cut type="feed"/>
						</epos-print>`;
                
                //Create a SOAP envelop
                var soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<s:Body>' + request + '</s:Body></s:Envelope>';
                //Create an XMLHttpRequest object
                var xhr = new XMLHttpRequest();
                //Set the end point address
                var url = 'http://'+this.ip1+'/cgi-bin/epos/service.cgi?devid='+this.devid1+'&timeout=40000';
                //Open an XMLHttpRequest object
                xhr.open('POST', url, true);
                //<Header settings>
                xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
                xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
                // Send print document
                xhr.send(soap);
		},
		TipoConteo(){
			if(this.modoPDV == 6){
				this.ConteoPython();
			} else
			{
				this.ImprimirConteo();
			}
		},
		async ConteoPython() {
			let dataParaImprimir = {
				usuario: this.$store.state.usuario.nombre,
				localidad: this.$store.state.usuario.localidad,
				moneda50000: this.moneda50000,
				moneda20000: this.moneda20000,
				moneda10000: this.moneda10000,
				moneda5000: this.moneda5000,
				moneda2000: this.moneda2000,
				moneda1000: this.moneda1000,
				moneda500: this.moneda500,
				moneda100: this.moneda100,
				moneda50: this.moneda50,
				moneda25: this.moneda25,
				moneda10: this.moneda10,
				ConteoColones: this.ConteoColones,
				TotalConteo: this.TotalConteo,
			};
			console.log(JSON.stringify(dataParaImprimir, null, 2));

			// Enviar los datos al servidor Python para imprimir
			try {
				const response = await axios.post('http://localhost:5000/conteo', dataParaImprimir);
				console.log('Conteo enviado a imprimir', response.data);
			} catch (error) {
				console.error('Error al enviar el conteo para imprimir', error);
			}
		},
		ImprimirConteo(){
			var momentoActual = new Date(); 
			var hora = momentoActual.getHours(); 
			var minuto = momentoActual.getMinutes(); 
			var segundo = momentoActual.getSeconds();
			var time = hora + ":" + minuto + ":" + segundo;
				if(this.ip1 == "" && this.devid1 == ""){
					//alert("No hay impresora designada");
					return;	
				}
				var request = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
						<text align="center"/>
						<text font="font_c"/>
						<text width="3" height="3"/>
						<text reverse="false" ul="false" em="false" color="color_1"/>
						<text>Conteo &#10;</text>
						<text width="1" height="1"/>
						<text>Usuario: `+this.$store.state.usuario.nombre+`&#9;</text>
						<text>Localidad:`+this.$store.state.usuario.localidad+` &#10;</text>
						<text>Hora `+time+`&#9;</text> <text>Fecha `+this.fecha+`&#9;</text>
						<text>-------------------------------------&#10;</text>
						<text align="left"/>
						<text>Billetes de 50.000:`+this.moneda50000+` &#10;</text>
						<text>Billetes de 20.000:`+this.moneda20000+` &#10;</text>
						<text>Billetes de 10.000:`+this.moneda10000+` &#10;</text>
						<text>Billetes de 5.000:`+this.moneda5000+` &#10;</text>
						<text>Billetes de 2.000:`+this.moneda2000+` &#10;</text>
						<text>Billetes de 1.000:`+this.moneda1000+` &#10;</text>
						<text>Billetes de 500:`+this.moneda500+` &#10;</text>
						<text>Billetes de 100:`+this.moneda100+` &#10;</text>
						<text>Billetes de 50:`+this.moneda50+` &#10;</text>
						<text>Billetes de 25:`+this.moneda25+` &#10;</text>
						<text>Billetes de 10:`+this.moneda10+` &#10;</text> 
						<text>Total: `+this.ConteoColones+` &#10;</text>
						<text>-------------------------------------&#10;</text>
						<text>Resumen Conteo:₡ `+this.TotalConteo+` &#10;</text>
						<feed line="3"/>
						<cut type="feed"/>
						<pulse drawer="drawer_1" time="pulse_100"/>
						</epos-print>`;
                
                //Create a SOAP envelop
                var soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<s:Body>' + request + '</s:Body></s:Envelope>';
                //Create an XMLHttpRequest object
                var xhr = new XMLHttpRequest();
                //Set the end point address
                var url = 'http://'+this.ip1+'/cgi-bin/epos/service.cgi?devid='+this.devid1+'&timeout=40000';
                //Open an XMLHttpRequest object
                xhr.open('POST', url, true);
                //<Header settings>
                xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
                xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
                // Send print document
                xhr.send(soap);
		},
		AbrirCajon(){
			var momentoActual = new Date(); 
			var hora = momentoActual.getHours(); 
			var minuto = momentoActual.getMinutes(); 
			var segundo = momentoActual.getSeconds();
			var time = hora + ":" + minuto + ":" + segundo;
				if(this.ip1 == "" && this.devid1 == ""){
					alert("No hay impresora designada");
					return;	
				}
				var request = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
							
						<pulse drawer="drawer_1" time="pulse_100"/>
						</epos-print>`;
                
                //Create a SOAP envelop
                var soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<s:Body>' + request + '</s:Body></s:Envelope>';
                //Create an XMLHttpRequest object
                var xhr = new XMLHttpRequest();
                //Set the end point address
                var url = 'http://'+this.ip1+'/cgi-bin/epos/service.cgi?devid='+this.devid1+'&timeout=40000';
                //Open an XMLHttpRequest object
                xhr.open('POST', url, true);
                //<Header settings>
                xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
                xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
                // Send print document
                xhr.send(soap);
		},
		async GenerarCierre(){
			this.dialogCierre = true;
			this.Mensaje = "Enviando correo, por favor espere..."
			this.snackbar = true;
			var CierreActual = this.Cierres.length;
			var idCierre = parseInt(CierreActual) +1;
			var DepositarEfectivo = parseInt(this.VentasColonesEfectivo) - parseInt(this.ImpServicio) - parseInt(this.TotalCompra);
			var TotalVentas = parseFloat(this.VentasColonesEfectivo) + parseFloat(this.VentasColonesTarjeta) +parseFloat(this.VentaTransferenciaColones) +parseFloat(this.VentaTotalSinpeColones);
			var mail = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
				<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<head>
				<meta charset="UTF-8">
				<meta content="width=device-width, initial-scale=1" name="viewport">
				<meta name="x-apple-disable-message-reformatting">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta content="telephone=no" name="format-detection">
				<title>Nuevo Cierre de Caja</title>
				<!--[if (mso 16)]>
				<style type="text/css">
				a {text-decoration: none;}
				</style>
				<![endif]-->
				<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--> 
				<!--[if gte mso 9]>
				<xml>
				<o:OfficeDocumentSettings>
				<o:AllowPNG></o:AllowPNG>
				<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
				</xml>
				<![endif]-->
				<!--[if !mso]><!-- -->
				<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i" rel="stylesheet">
				<link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet">
				<!--<![endif]-->
				<style type="text/css">
				#outlook a {
				padding:0;
				}
				.ExternalClass {
				width:100%;
				}
				.ExternalClass,
				.ExternalClass p,
				.ExternalClass span,
				.ExternalClass font,
				.ExternalClass td,
				.ExternalClass div {
				line-height:100%;
				}
				.es-button {
				mso-style-priority:100!important;
				text-decoration:none!important;
				}
				a[x-apple-data-detectors] {
				color:inherit!important;
				text-decoration:none!important;
				font-size:inherit!important;
				font-family:inherit!important;
				font-weight:inherit!important;
				line-height:inherit!important;
				}
				.es-desk-hidden {
				display:none;
				float:left;
				overflow:hidden;
				width:0;
				max-height:0;
				line-height:0;
				mso-hide:all;
				}
				.es-button-border:hover a.es-button, .es-button-border:hover button.es-button {
				background:#ffffff!important;
				border-color:#ffffff!important;
				}
				.es-button-border:hover {
				background:#ffffff!important;
				border-style:solid solid solid solid!important;
				border-color:#3d5ca3 #3d5ca3 #3d5ca3 #3d5ca3!important;
				}
				[data-ogsb] .es-button {
				border-width:0!important;
				padding:15px 20px 15px 20px!important;
				}
				@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1 { font-size:20px!important; text-align:center; line-height:120%!important } h2 { font-size:16px!important; text-align:left; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:20px!important } h2 a { text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:16px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:14px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:10px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:12px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } a.es-button, button.es-button { font-size:14px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
				</style>
				</head>
				<body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<div class="es-wrapper-color" style="background-color:#FAFAFA">
				<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#fafafa"></v:fill>
				</v:background>
				<![endif]-->
				<table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td valign="top" style="padding:0;Margin:0">
				<table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td class="es-adaptive" align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:10px;Margin:0">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:580px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" class="es-infoblock" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">Nuevo cierre de caja exitoso</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td class="es-adaptive" align="center" style="padding:0;Margin:0">
				<table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#3D5CA3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#3d5ca3" align="center">
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:20px;padding-bottom:20px;padding-left:20px;padding-right:20px;background-color:#1F4168" bgcolor="#1F4168" align="left">
				<!--[if mso]><table style="width:560px" cellpadding="0"
				cellspacing="0"><tr><td style="width:270px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:270px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-m-p0l es-m-txt-c" align="left" style="padding:0;Margin:0;font-size:0px"><a href="https://www.noah.cr" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#1376C8;font-size:14px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_65e89905d0cd1cf04350dadec210c09f/images/65101622684174168.png" alt="NUEVO CIERRE" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="63" title="NUEVO CIERRE"></a></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:270px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:270px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="right" style="padding:0;Margin:0;padding-top:10px"><span class="es-button-border" style="border-style:solid;border-color:#3D5CA3;background:#FFFFFF;border-width:2px;display:inline-block;border-radius:10px;width:auto"><a href="https://chat.whatsapp.com/DGSSGdXIZd98DpWH5QxiVr" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#42A5F6;font-size:14px;border-style:solid;border-color:#FFFFFF;border-width:15px 20px 15px 20px;display:inline-block;background:#FFFFFF;border-radius:10px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">Contáctanos WhatsApp</a></span></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-left:20px;padding-right:20px;padding-top:40px;background-color:transparent;background-position:left top" bgcolor="transparent" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:left top" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:5px;font-size:0"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_dd354a98a803b60e2f0411e893c82f56/images/23891556799905703.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="175"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:15px;padding-bottom:15px"><h1 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:normal;color:#42A5F6"><b>CIERRE DE CAJA</b></h1></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-left:40px;padding-right:40px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#666666;font-size:16px">Hola, gracias por preferirnos, acá esta tu cierre de hoy</p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-right:35px;padding-left:40px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#666666;font-size:16px">
				`+this.localidadencabezado[0].nombre+ `<br>`+  `
				`+this.localidadencabezado[0].razonSocial+ `<br>`+  `
				`+this.localidadencabezado[0].dirreccion+ `<br>`+  `
				`+this.localidadencabezado[0].cedulaJuridica+ `<br>`+  `
				`+this.localidadencabezado[0].telefono+ `<br>`+  `
				`+this.localidadencabezado[0].correo+ `<br>`+  
				`-------------------------------------- <br> 
				`+this.fecha+ `<br>`+  `
				Usuario: `+this.$store.state.usuario.nombre+ `<br>`+  `
				Id Cierre`+idCierre+ `<br>`+  `
				-------------------------------------- <br> 
				Billetes de 50.000:`+this.moneda50000+` <br> 
				Billetes de 20.000:`+this.moneda20000+` <br> 
				Billetes de 10.000:`+this.moneda10000+` <br> 
				Billetes de 5.000:`+this.moneda5000+` <br> 
				Billetes de 2.000:`+this.moneda2000+` <br> 
				Billetes de 1.000:`+this.moneda1000+` <br> 
				Monedas de 500:`+this.moneda500+` <br> 
				Monedas de 100:`+this.moneda100+` <br> 
				Monedas de 50:`+this.moneda50+` <br> 
				Monedas de 25:`+this.moneda25+` <br> 
				Monedas de 10:`+this.moneda10+`<br> 
				Total: `+this.ConteoColones+` <br> 
				-------------------------------------- <br> 
				Ingresado Promerica`+this.ConteoDatafonoPromerica+ `<br>`+  `
				Ingresado BCR`+this.ConteoDatafonoBCR+ `<br>`+  `
				Ingresado BAC`+this.ConteoDatafonoBAC+ `<br>`+  `
				Ingresado Nacional`+this.ConteoDatafonoNacional+ `<br>`+  `
				Ingresado Lafise`+this.ConteoDatafonoLafise+ `<br>
				------------------------------------- <br> 
				<text>Resumen Conteo: ₡`+this.TotalConteo+` <br> 
				<text>Resumen Conteo $: `+this.monedaDolar+` <br> 
				<text>Fondo de Caja Colones `+this.FondoColones+` <br> 
				<text>Fondo de Caja Dolares`+this.FondoDolares+` <br> 
				<text>Compras Caja Chica Colones `+this.TotalCompras+`<br> 
				<text>IVA  ₡`+this.ivaColones+`<br> 
				<text>IVA  $`+this.ivaDolares+`<br> 
				<text>------------------------------------<br> 
				
				<text>Ventas Efectivo ₡`+this.VentasColonesEfectivo+` <br> 
				<text>Ventas Tarjeta:₡ `+this.VentasColonesTarjeta+` <br> 
				<text>Ventas en Transferencia: ₡ `+this.VentaTransferenciaColones+` <br> 
				<text>Ventas en Sinpe:  ₡`+this.VentaTotalSinpeColones+` <br> 
				<text>Diferencia Efectivo: ₡`+this.DiferenciaColones+` <br> 
				<text>Diferencia Efectivo: $`+this.DiferenciaDolares +` <br> 
				<text>Conteo Tarjetas `+this.TotalTarjetas+` <br> 
				<text>Diferencia Tarjetas: ₡`+this.DiferenciaTarjetas+` <br> 
				
				<text>------------------------------------<br> 
				<text>Facturas a crédito: `+this.FacturasCredito+` <br> 
				<text>Abonos Crédito Efectivo `+this.CreditosEfectivo+` <br> 
				<text>Abonos Crédito Tarjetas: `+this.CreditosTarjeta+` <br> 
				<text>Abonos Crédito Transferencias: `+this.CreditosDepositos+` <br> 
				<text>Abonos Crédito Sinpe: `+this.CreditosSinpe+` <br> 
				<text>------------------------------------<br> 
				<text>Notas de credito Efectivo:  `+this.NotasCreditoEfectivoColones +` <br> 
				<text>Notas de credito Tarjeta:  `+this.NotasCreditoTarjetaColones+` <br> 
				<text>Total Ventas:  `+ TotalVentas +` <br> 
				<text>Imp Servicio:  ₡`+this.ImpServicio+` <br> 
				<text>Salon :  ₡`+this.VentasServicio+` <br> 
				<text>Bar :  ₡`+this.VentasSinServicioo+` <br> 
				<text>Imp Servicio:  ₡`+this.ImpServicio+` <br> 
				<text>Retiro Efectivo:  ₡`+ this.RetiroEfectvo +`  `+  `</p>
				</td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-left:10px;padding-right:10px;padding-top:20px;background-position:center center" align="left">
				<!--[if mso]><table style="width:580px" cellpadding="0" cellspacing="0"><tr><td style="width:199px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:199px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:center center" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="right" style="padding:0;Margin:0;padding-top:15px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:24px;color:#666666;font-size:16px"><strong>Siguenos:</strong></p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:361px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:361px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:center center" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-bottom:5px;padding-top:10px;font-size:0">
				<table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.facebook.com/NoahSystemsCR" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/facebook-rounded-gray.png" alt="Fb" title="Facebook" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.instagram.com/noah.systems/?hl=es-la" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/twitter-rounded-gray.png" alt="Tw" title="Twitter" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.instagram.com/noah.systems/?hl=es-la" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/instagram-rounded-gray.png" alt="Ig" title="Instagram" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0"><a target="_blank" href="https://www.youtube.com/channel/UCpMW0Xdqdha04qh6ehq3v-A" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/youtube-rounded-gray.png" alt="Yt" title="Youtube" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:5px;padding-bottom:20px;padding-left:20px;padding-right:20px;background-position:left top" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#666666;font-size:14px">Contacto: +506 4070-1889| <a target="_blank" href="mailto:your@mail.com" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#666666;font-size:14px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif">i</a>nfo@noah-systems.net</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-footer" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-footer-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px">
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:10px;padding-left:20px;padding-right:20px;padding-bottom:30px;background-color:#1F4168" bgcolor="#1F4168" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:5px"><h2 style="Margin:0;line-height:19px;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-size:16px;font-style:normal;font-weight:normal;color:#FFFFFF"><strong>Tienes consultas?</strong></h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:5px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#FFFFFF;font-size:14px">Contáctanos vía WhatsApp&nbsp;</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="transparent" align="center">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-top:15px;background-position:left top" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:600px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0">
				<table class="es-menu" width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr class="links" style="border-collapse:collapse">
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0" id="esd-menu-id-0" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr/login" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">LOGIN</a></td>
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0;border-left:1px solid #3D5CA3" id="esd-menu-id-1" esdev-border-color="#3d5ca3" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">BLOG</a></td>
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0;border-left:1px solid #3D5CA3" id="esd-menu-id-2" esdev-border-color="#3d5ca3" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">SERVICIOS</a></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:20px;padding-left:20px;padding-right:20px;font-size:0">
				<table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;border-bottom:1px solid #FAFAFA;background:none;height:1px;width:100%;margin:0px"></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-footer" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="transparent" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-bottom:5px;padding-top:15px;padding-left:20px;padding-right:20px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Este correo fue generado de forma automática, por favor no responda ya que no obtendrá respuesta</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:0px;font-size:0px;color:#CCCCCC"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#CCCCCC;font-size:12px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_65e89905d0cd1cf04350dadec210c09f/images/46871622684957570.png" alt="Visita nuestra plataforma de facturación" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="125" title="Visita nuestra plataforma de facturación"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				</div>
				</body>
				</html>`;
		var linkProforma = location.origin+'/pos';
		var tipo = 'CIERRE DE CAJA'
		var self = this;
		this.loading = false;
		let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
		await axios.post('api/CierreCajas/Crear',{
				'Localidad':this.$store.state.usuario.localidad,
				'Cajero':this.$store.state.usuario.nombre,
				'Efectivo': this.VentasColonesEfectivo,
				'Tarjetas':this.VentasColonesTarjeta,
				'DiferenciaE':this.DiferenciaColones,
				'DiferenciaT':this.DiferenciaTarjetas,
				'NumeroC':this.Cierres.length +1,
				'MontoExpress':0,
				'PagosCredito':0,
				'PagosProveedores':this.TotalCompras,
				'VentasCredito':this.CreditosEfectivo+this.CreditosTarjeta+this.CreditosDepositos +this.CreditosSinpe,
				'GastosFijos':0,
				'Deposito':this.VentaTransferenciaColones + this.VentaTotalSinpeColones, 
				'Dolares':this.VentasDolaresEfectivo + this.VentasDolaresTarjeta,
				'DiferenciaD':this.DiferenciaDolares,
				'NotasCredito':this.NotasCreditoEfectivoColones + this.NotasCreditoTarjetaColones + this.NotasCreditoTranferenciaColones,
				'TBAC':this.ConteoDatafonoBAC,
				'TBN':this.ConteoDatafonoNacional,
				'TPROM':this.ConteoDatafonoPromerica,
				'TOTRO':this.ConteoDatafonoBCR + this.ConteoDatafonoLafise,
				'DepositadoEfe':this.VentaTransferenciaColones +this.VentaTotalSinpeDolares,
				'DepositadoDol':this.VentasDolaresEfectivo,
				'CodigoCierre':this.Cierres.length + 1,
				'EC_Estado':1,
				'Mail':mail,
			},configuracion).then(function (response) {
			
			alert("Cierre de Caja Exitoso");
			if(self.ip1 == ""){
					return;
				}
				self.ImprimirCierre();
			}).catch(function(error){
				alert('Cierre de Caja con problema'+ error);
			}); 
		},
		async GenerarCierreGlobal(){
			this.dialogCierre = true;
			this.Mensaje = "Enviando correo, por favor espere..."
			this.snackbar = true;
			this.loading = false;
			var CierreActual = this.Cierres.length;
			var idCierre = parseInt(CierreActual) +1;
			var DepositarEfectivo = parseInt(this.VentasColonesEfectivo) - parseInt(this.ImpServicio) - parseInt(this.TotalCompra);
			var TotalVentas = parseFloat(this.VentasColonesEfectivo) + parseFloat(this.VentasColonesTarjeta) +parseFloat(this.VentaTransferenciaColones) +parseFloat(this.VentaTotalSinpeColones);
			var mail = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
				<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<head>
				<meta charset="UTF-8">
				<meta content="width=device-width, initial-scale=1" name="viewport">
				<meta name="x-apple-disable-message-reformatting">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta content="telephone=no" name="format-detection">
				<title>Nuevo Cierre de Caja</title>
				<!--[if (mso 16)]>
				<style type="text/css">
				a {text-decoration: none;}
				</style>
				<![endif]-->
				<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--> 
				<!--[if gte mso 9]>
				<xml>
				<o:OfficeDocumentSettings>
				<o:AllowPNG></o:AllowPNG>
				<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
				</xml>
				<![endif]-->
				<!--[if !mso]><!-- -->
				<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i" rel="stylesheet">
				<link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet">
				<!--<![endif]-->
				<style type="text/css">
				#outlook a {
				padding:0;
				}
				.ExternalClass {
				width:100%;
				}
				.ExternalClass,
				.ExternalClass p,
				.ExternalClass span,
				.ExternalClass font,
				.ExternalClass td,
				.ExternalClass div {
				line-height:100%;
				}
				.es-button {
				mso-style-priority:100!important;
				text-decoration:none!important;
				}
				a[x-apple-data-detectors] {
				color:inherit!important;
				text-decoration:none!important;
				font-size:inherit!important;
				font-family:inherit!important;
				font-weight:inherit!important;
				line-height:inherit!important;
				}
				.es-desk-hidden {
				display:none;
				float:left;
				overflow:hidden;
				width:0;
				max-height:0;
				line-height:0;
				mso-hide:all;
				}
				.es-button-border:hover a.es-button, .es-button-border:hover button.es-button {
				background:#ffffff!important;
				border-color:#ffffff!important;
				}
				.es-button-border:hover {
				background:#ffffff!important;
				border-style:solid solid solid solid!important;
				border-color:#3d5ca3 #3d5ca3 #3d5ca3 #3d5ca3!important;
				}
				[data-ogsb] .es-button {
				border-width:0!important;
				padding:15px 20px 15px 20px!important;
				}
				@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1 { font-size:20px!important; text-align:center; line-height:120%!important } h2 { font-size:16px!important; text-align:left; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:20px!important } h2 a { text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:16px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:14px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:10px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:12px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } a.es-button, button.es-button { font-size:14px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
				</style>
				</head>
				<body style="width:100%;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<div class="es-wrapper-color" style="background-color:#FAFAFA">
				<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#fafafa"></v:fill>
				</v:background>
				<![endif]-->
				<table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td valign="top" style="padding:0;Margin:0">
				<table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td class="es-adaptive" align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:10px;Margin:0">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:580px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" class="es-infoblock" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">Nuevo cierre de caja exitoso</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table cellpadding="0" cellspacing="0" class="es-header" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td class="es-adaptive" align="center" style="padding:0;Margin:0">
				<table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#3D5CA3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#3d5ca3" align="center">
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:20px;padding-bottom:20px;padding-left:20px;padding-right:20px;background-color:#1F4168" bgcolor="#1F4168" align="left">
				<!--[if mso]><table style="width:560px" cellpadding="0"
				cellspacing="0"><tr><td style="width:270px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:270px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-m-p0l es-m-txt-c" align="left" style="padding:0;Margin:0;font-size:0px"><a href="https://www.noah.cr" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#1376C8;font-size:14px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_65e89905d0cd1cf04350dadec210c09f/images/65101622684174168.png" alt="NUEVO CIERRE" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="63" title="NUEVO CIERRE"></a></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:270px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:270px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="right" style="padding:0;Margin:0;padding-top:10px"><span class="es-button-border" style="border-style:solid;border-color:#3D5CA3;background:#FFFFFF;border-width:2px;display:inline-block;border-radius:10px;width:auto"><a href="https://chat.whatsapp.com/DGSSGdXIZd98DpWH5QxiVr" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#42A5F6;font-size:14px;border-style:solid;border-color:#FFFFFF;border-width:15px 20px 15px 20px;display:inline-block;background:#FFFFFF;border-radius:10px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-weight:bold;font-style:normal;line-height:17px;width:auto;text-align:center">Contáctanos WhatsApp</a></span></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-left:20px;padding-right:20px;padding-top:40px;background-color:transparent;background-position:left top" bgcolor="transparent" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:left top" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:5px;padding-bottom:5px;font-size:0"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_dd354a98a803b60e2f0411e893c82f56/images/23891556799905703.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="175"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:15px;padding-bottom:15px"><h1 style="Margin:0;line-height:24px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:20px;font-style:normal;font-weight:normal;color:#42A5F6"><b>CIERRE DE CAJA</b></h1></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-left:40px;padding-right:40px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#666666;font-size:16px">Hola, gracias por preferirnos, acá esta tu cierre de hoy</p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-right:35px;padding-left:40px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#666666;font-size:16px">
				`+this.localidadencabezado[0].nombre+ `<br>`+  `
				`+this.localidadencabezado[0].razonSocial+ `<br>`+  `
				`+this.localidadencabezado[0].dirreccion+ `<br>`+  `
				`+this.localidadencabezado[0].cedulaJuridica+ `<br>`+  `
				`+this.localidadencabezado[0].telefono+ `<br>`+  `
				`+this.localidadencabezado[0].correo+ `<br>`+  
				`-------------------------------------- <br> 
				`+this.fecha+ `<br>`+  `
				Usuario: `+this.$store.state.usuario.nombre+ `<br>`+  `
				Id Cierre`+idCierre+ `<br>`+  `
				-------------------------------------- <br> 
				Billetes de 50.000:`+this.moneda50000+` <br> 
				Billetes de 20.000:`+this.moneda20000+` <br> 
				Billetes de 10.000:`+this.moneda10000+` <br> 
				Billetes de 5.000:`+this.moneda5000+` <br> 
				Billetes de 2.000:`+this.moneda2000+` <br> 
				Billetes de 1.000:`+this.moneda1000+` <br> 
				Monedas de 500:`+this.moneda500+` <br> 
				Monedas de 100:`+this.moneda100+` <br> 
				Monedas de 50:`+this.moneda50+` <br> 
				Monedas de 25:`+this.moneda25+` <br> 
				Monedas de 10:`+this.moneda10+`<br> 
				Total: `+this.ConteoColones+` <br> 
				-------------------------------------- <br> 
				Ingresado Promerica`+this.ConteoDatafonoPromerica+ `<br>`+  `
				Ingresado BCR`+this.ConteoDatafonoBCR+ `<br>`+  `
				Ingresado BAC`+this.ConteoDatafonoBAC+ `<br>`+  `
				Ingresado Nacional`+this.ConteoDatafonoNacional+ `<br>`+  `
				Ingresado Lafise`+this.ConteoDatafonoLafise+ `<br>
				------------------------------------- <br> 
				<text>Resumen Conteo: ₡`+this.TotalConteo+` <br> 
				<text>Resumen Conteo $: `+this.monedaDolar+` <br> 
				<text>Fondo de Caja Colones `+this.FondoColones+` <br> 
				<text>Fondo de Caja Dolares`+this.FondoDolares+` <br> 
				<text>Compras Caja Chica Colones `+this.TotalCompras+`<br> 
				<text>IVA  ₡`+this.ivaColones+`<br> 
				<text>IVA  $`+this.ivaDolares+`<br> 
				<text>------------------------------------<br> 
				
				<text>Ventas Efectivo ₡`+this.VentasColonesEfectivo+` <br> 
				<text>Ventas Tarjeta:₡ `+this.VentasColonesTarjeta+` <br> 
				<text>Ventas en Transferencia: ₡ `+this.VentaTransferenciaColones+` <br> 
				<text>Ventas en Sinpe:  ₡`+this.VentaTotalSinpeColones+` <br> 
				<text>Diferencia Efectivo: ₡`+this.DiferenciaColones+` <br> 
				<text>Diferencia Efectivo: $`+this.DiferenciaDolares +` <br> 
				<text>Conteo Tarjetas `+this.TotalTarjetas+` <br> 
				<text>Diferencia Tarjetas: ₡`+this.DiferenciaTarjetas+` <br> 
				
				<text>------------------------------------<br> 
				<text>Facturas a crédito: `+this.FacturasCredito+` <br> 
				<text>Abonos Crédito Efectivo `+this.CreditosEfectivo+` <br> 
				<text>Abonos Crédito Tarjetas: `+this.CreditosTarjeta+` <br> 
				<text>Abonos Crédito Transferencias: `+this.CreditosDepositos+` <br> 
				<text>Abonos Crédito Sinpe: `+this.CreditosSinpe+` <br> 
				<text>------------------------------------<br> 
				<text>Notas de credito Efectivo:  `+this.NotasCreditoEfectivoColones +` <br> 
				<text>Notas de credito Tarjeta:  `+this.NotasCreditoTarjetaColones+` <br> 
				<text>Total Ventas:  `+ TotalVentas +` <br> 
				<text>Imp Servicio:  ₡`+this.ImpServicio+` <br> 
				<text>Salon :  ₡`+this.VentasServicio+` <br> 
				<text>Bar :  ₡`+this.VentasSinServicioo+` <br> 
				<text>Imp Servicio:  ₡`+this.ImpServicio+` <br> 
				<text>Retiro Efectivo:  ₡`+ this.RetiroEfectvo +`  `+  `</p>
				</td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-left:10px;padding-right:10px;padding-top:20px;background-position:center center" align="left">
				<!--[if mso]><table style="width:580px" cellpadding="0" cellspacing="0"><tr><td style="width:199px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:199px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:center center" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="right" style="padding:0;Margin:0;padding-top:15px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:24px;color:#666666;font-size:16px"><strong>Siguenos:</strong></p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:361px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:361px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-position:center center" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td class="es-m-txt-c" align="left" style="padding:0;Margin:0;padding-bottom:5px;padding-top:10px;font-size:0">
				<table class="es-table-not-adapt es-social" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.facebook.com/NoahSystemsCR" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/facebook-rounded-gray.png" alt="Fb" title="Facebook" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.instagram.com/noah.systems/?hl=es-la" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/twitter-rounded-gray.png" alt="Tw" title="Twitter" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0;padding-right:10px"><a target="_blank" href="https://www.instagram.com/noah.systems/?hl=es-la" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/instagram-rounded-gray.png" alt="Ig" title="Instagram" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				<td valign="top" align="center" style="padding:0;Margin:0"><a target="_blank" href="https://www.youtube.com/channel/UCpMW0Xdqdha04qh6ehq3v-A" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#0B5394;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/assets/img/social-icons/rounded-gray/youtube-rounded-gray.png" alt="Yt" title="Youtube" width="32" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:5px;padding-bottom:20px;padding-left:20px;padding-right:20px;background-position:left top" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#666666;font-size:14px">Contacto: +506 4070-1889| <a target="_blank" href="mailto:your@mail.com" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#666666;font-size:14px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif">i</a>nfo@noah-systems.net</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-footer" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-footer-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px">
				<tr style="border-collapse:collapse">
				<td style="Margin:0;padding-top:10px;padding-left:20px;padding-right:20px;padding-bottom:30px;background-color:#1F4168" bgcolor="#1F4168" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:5px;padding-bottom:5px"><h2 style="Margin:0;line-height:19px;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-size:16px;font-style:normal;font-weight:normal;color:#FFFFFF"><strong>Tienes consultas?</strong></h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:5px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#FFFFFF;font-size:14px">Contáctanos vía WhatsApp&nbsp;</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="transparent" align="center">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;padding-top:15px;background-position:left top" align="left">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:600px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0">
				<table class="es-menu" width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr class="links" style="border-collapse:collapse">
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0" id="esd-menu-id-0" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr/login" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">LOGIN</a></td>
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0;border-left:1px solid #3D5CA3" id="esd-menu-id-1" esdev-border-color="#3d5ca3" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">BLOG</a></td>
				<td style="Margin:0;padding-left:5px;padding-right:5px;padding-top:0px;padding-bottom:1px;border:0;border-left:1px solid #3D5CA3" id="esd-menu-id-2" esdev-border-color="#3d5ca3" width="33.33%" valign="top" bgcolor="transparent" align="center"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;display:block;color:#3D5CA3;font-size:14px">SERVICIOS</a></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:20px;padding-left:20px;padding-right:20px;font-size:0">
				<table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;border-bottom:1px solid #FAFAFA;background:none;height:1px;width:100%;margin:0px"></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-footer" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;background-color:#FAFAFA" bgcolor="#fafafa" align="center">
				<table class="es-footer-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="transparent" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-bottom:5px;padding-top:15px;padding-left:20px;padding-right:20px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:helvetica, 'helvetica neue', arial, verdana, sans-serif;line-height:18px;color:#666666;font-size:12px">Este correo fue generado de forma automática, por favor no responda ya que no obtendrá respuesta</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-infoblock made_with" align="center" style="padding:0;Margin:0;line-height:0px;font-size:0px;color:#CCCCCC"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#CCCCCC;font-size:12px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_65e89905d0cd1cf04350dadec210c09f/images/46871622684957570.png" alt="Visita nuestra plataforma de facturación" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="125" title="Visita nuestra plataforma de facturación"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				</div>
				</body>
				</html>`;
		var linkProforma = location.origin+'/pos';
		var tipo = 'CIERRE DE CAJA'
		var self = this;
		this.loading = true;
		let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
		await axios.post('api/CierreCajas/CrearGlobal',{
				'Localidad':this.$store.state.usuario.localidad,
				'Cajero':this.$store.state.usuario.nombre,
				'Efectivo': this.VentasColonesEfectivo,
				'Tarjetas':this.VentasColonesTarjeta,
				'DiferenciaE':this.DiferenciaColones,
				'DiferenciaT':this.DiferenciaTarjetas,
				'NumeroC':this.Cierres.length +1,
				'MontoExpress':0,
				'PagosCredito':0,
				'PagosProveedores':this.TotalCompras,
				'VentasCredito':this.CreditosEfectivo+this.CreditosTarjeta+this.CreditosDepositos +this.CreditosSinpe,
				'GastosFijos':0,
				'Deposito':this.VentaTransferenciaColones + this.VentaTotalSinpeColones, 
				'Dolares':this.VentasDolaresEfectivo + this.VentasDolaresTarjeta,
				'DiferenciaD':this.DiferenciaDolares,
				'NotasCredito':this.NotasCreditoEfectivoColones + this.NotasCreditoTarjetaColones + this.NotasCreditoTranferenciaColones,
				'TBAC':this.ConteoDatafonoBAC,
				'TBN':this.ConteoDatafonoNacional,
				'TPROM':this.ConteoDatafonoPromerica,
				'TOTRO':this.ConteoDatafonoBCR + this.ConteoDatafonoLafise,
				'DepositadoEfe':this.VentaTransferenciaColones +this.VentaTotalSinpeDolares,
				'DepositadoDol':this.VentasDolaresEfectivo,
				'CodigoCierre':this.Cierres.length + 1,
				'EC_Estado':1,
				'Mail':mail,
			},configuracion).then(function (response) {
			self.Mensaje = "Cierre de Caja Exitoso";
			self.snackbar = true;
			self.loading = false;
			if(self.ip1 == ""){
					return;
				}
				self.ImprimirCierre();
			}).catch(function(error){
				alert('Cierre de Caja con problema'+ error);
			}); 
		},
		Cierre(){
			this.$store.dispatch("salir");
		},
		ReimprimirCierre(item){
			var link = location.origin+'/cierre/'+item.numeroC;
			location.assign(link);
		},
		ImprimirCierrePOS(item){
			var No = this.Cierres.length + 1
			var divContents = document.getElementById("bill").innerHTML;
			var a = window.open('', '', 'height=500, width=500');
			a.document.write('<html>');
			a.document.write(divContents);
			a.document.write('</body></html>');
			a.print();
		},
		Limpiar(){
		location.reload();
		},

    },
  }
</script>


<style lang="scss">>
    #espacioBoton {
        top: 10px;
    }
    /*#clienteBoton {
        bottom: 10px;
    }*/
    /* #clienteActualizar {
        bottom: 5px;
    }*/
    .content {
    max-width: 400px;
    margin: auto;
    }
    #factura {
        padding: 20px;
    }
    #ticket {
    width: 60px;
    max-width: 155px;
    }

    
    @import url('https://fonts.googleapis.com/css2?family=ABeeZee&family=Montserrat:wght@200;400&family=Open+Sans:wght@600&family=PT+Sans&display=swap');

    #logo {
        float: left;
        margin-left: 2%;
        margin-right: 2%;
    }
    #imagen {
        width: 100px;
    }

    #fact {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }   

    #datos {
        float: left;
        margin-top: 0%;
        margin-left: 2%;
        margin-right: 2%;
    }

    #encabezado {
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
        font-size: 16px;
    }

    section {
        clear: left;
    }

    #cliente {
        text-align: left;
    }

    #facliente {
        width: 40%;
        border-collapse: collapse;
        border-spacing: 0;
        margin-bottom: 15px;
    }

    #fa {
        color: #FFFFFF;
        font-size: 14px;
    }
    @media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
    }   
    #facarticulo {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        padding: 20px;
        margin-bottom: 15px;
    }

    #facarticulo thead {
        padding: 20px;
        background: #2183E3;
        text-align: center;
        border-bottom: 1px solid #FFFFFF;
    }

    #gracias {
        text-align: center;
    }
    tr.v-data-table__selected {
      background: #7d92f5 !important;
    }

    button#facturaBoton {
      margin: 18px;
    }

    button#hoyBoton {
      margin: 18px;
    }

    .tarjeta{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .efectivo{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .btnLimpiarGrid {
        margin-bottom: 20px;
    }

    button#productoBoton {
        top: 6px;
        margin-left: 35px;
    }

    td,
    th,
    tr,

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%!important;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }

    

    img {
        max-width: inherit;
        width: inherit;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }

    .ticket {
        width: 220px;
        max-width: 220px;
    }

    img {
        max-width: inherit;
        width: inherit;
    }

</style>
